var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#FFE379"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5361 30.9007C18.4155 39.1413 22.5763 48.422 30.898 51.4622C39.2196 54.5024 48.4215 50.3421 51.4621 42.1015C54.5027 33.861 50.3419 24.5803 42.1002 21.5401C40.3399 20.82 38.4195 20.5 36.4991 20.5C35.7602 20.5 34.9809 20.5807 34.2187 20.7135C33.9078 20.7677 34.2187 35 34.2187 35L21.5361 30.9007Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.499 19.3586C38.6375 19.3586 40.6886 19.7295 42.4952 20.4692C51.3046 23.7189 55.8005 33.6405 52.5328 42.4966C49.2775 51.3189 39.4272 55.7933 30.5063 52.5342C21.7015 49.3174 17.204 39.5544 20.3704 30.7626L20.4687 30.4965L22.6034 31.3049C19.697 38.9797 23.5934 47.5785 31.2896 50.3902C39.0359 53.2202 47.574 49.3418 50.3913 41.7064C53.2249 34.027 49.3255 25.4218 41.6681 22.5964C40.1104 21.9592 38.352 21.6413 36.499 21.6413C35.9665 21.6413 35.3863 21.6885 34.7807 21.7787L34.4145 21.8379L34.0227 19.5891C34.8836 19.4391 35.7205 19.3586 36.499 19.3586Z",
    fill: "#3B3A40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9639 20.25C26.2116 17.733 30.1868 16.3586 34.2391 16.3586C34.8694 16.3586 35.3804 16.8696 35.3804 17.4999V34.9999C35.3804 35.7525 34.6648 36.299 33.9388 36.101L17.1997 31.5358C16.5945 31.3708 16.236 30.7483 16.3968 30.1421C17.4422 26.2018 19.7745 22.7034 22.9639 20.25ZM33.0978 33.5049V18.6832L32.8263 18.7051C29.7778 18.9804 26.8314 20.1407 24.3589 22.0568C21.9373 23.9196 20.078 26.4726 19.0289 29.3681L18.9327 29.642L33.0978 33.5049Z",
    fill: "#3B3A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyse);
export default __webpack_public_path__ + "static/media/analyse.ef07cdd77f7b68648c4952c404bad2e1.svg";
export { ForwardRef as ReactComponent };